function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { forwardRef, omitThemingProps, StylesProvider, tqc, useMultiStyleConfig, useStyles } from '../../../system';
export var DetailsCardHeader = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    __css: styles.header
  }, props));
});
export var DetailsCardBody = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    __css: styles.body
  }, props));
});
export var DetailsCardFooter = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref
  }, props, {
    __css: styles.footer
  }));
});
export var DetailsCard = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('DetailsCard', props);
  var detailsCardProps = omitThemingProps(props);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    __css: styles.container
  }, detailsCardProps)));
});